var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FeedWrapper',{staticClass:"channel-feed",attrs:{"has-items":_vm.channels.length !== 0,"all-loaded":_vm.allLoaded}},_vm._l((_vm.channels),function(channel){return _c('ChannelComponent',{key:channel.id,attrs:{"channel":channel}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }